import React from "react";
import './SolutionFormStyle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'


function LogisticsForm() {

  return (
    <div>

      <div class="modal" id="LogisticsForm">
        <div class="modal__content form_modal">
          <div class="modal__wrapper">
            <a href="#return" class="modal__close">✕</a>
            <div className="modal_form">
              <div class="Modal_form_hdng">
                <h2>Partner with us</h2>
                <p>Please provide all required details to register your business with us</p>
              </div>

              <form className="modalform_wrapper" method="post" action="https://submit-form.com/7bz4Jhbn">
                <h4 className="hdng">Business owner</h4>
                <div className="input-group left_input required">
                  <label>First name</label>
                  <input type="text" name="firstName" required/>
                </div>
                <div className="input-group right_input required">
                  <label>Last name</label>
                  <input type="text" name="lastName" required />
                </div>

                <div className="input-group required">
                  <label>Business name</label>
                  <input type="text" name="businessName" required />
                </div>

                <div className="input-group left_input required">
                  <label>Contact number</label>
                  <input type="text" placeholder="0801-234-5678" name="contactPhoneNo" required />
                </div>
                <div className="input-group right_input">
                  <label>Email</label>
                  <input type="text" name="emailAddress" />
                </div>
                <h4 className="hdng">Address</h4>
                <div className="input-group required">
                  <label>Street Address</label>
                  <input type="text" name="addressLine1" required />
                </div>
                <div className="input-group">
                  <label>Street Address Line 2</label>
                  <input type="text" name="addressLine2" />
                </div>
                <div className="input-group left_input required">
                  <label>State</label>
                  <input type="text" name="state" required />
                </div>
                <div className="input-group right_input required">
                  <label>City</label>
                  <input type="text" name="city" required />
                </div>
                <div className="input-group required">
                  <label>Which E-commerce companies are you working with currently?</label>
                  <input type="text" name="associatedECommerceCompanies" required />
                </div>
                <div className="input-group">
                  <label>Message</label>
                  <textarea name="message"></textarea>
                </div>
                <div className="input-droup">
                  <button type="submit" className="submit">Continue <FontAwesomeIcon icon={faArrowRight} /></button>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>

    </div>

  )
}

export default LogisticsForm